var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.loading, hasData: !_vm.loading } },
        [
          _c("router-view", {
            staticClass: "relative",
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              authenticated: _vm.isAuthenticated,
            },
            on: { refetch: _vm.onRefetch, signOut: _vm.clearUserInfo },
          }),
          _vm.myTimerRunning
            ? _c(
                "Tooltip",
                {
                  staticClass:
                    "flex flex-row absolute z-10 bottom-6 right-20 rounded-xl bg-lightGreen shadow-xs cursor-pointer",
                  attrs: {
                    title: _vm.myTimerTitle,
                    variant: _vm.TooltipVariants.LIGHT,
                    placement: "top",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      on: {
                        click: function ($event) {
                          return _vm.saveTimer()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-center items-center space-x-2 px-5 py-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-5 w-5 bg-white rounded-full flex justify-center items-center",
                            },
                            [
                              _c("div", {
                                staticClass: "h-2 w-2 bg-stopButton flex",
                              }),
                            ]
                          ),
                          _c("div", { attrs: { id: "appTimerLabel" } }, [
                            _vm._v("00:00:00"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }